import {Flex, Text} from '@chakra-ui/react';
import React from 'react';

export const WizardContent = ({
  title,
  children,
  footer,
}: {
  title: string;
  children: React.ReactNode;
  footer?: string;
}) => (
  <Flex
    flex="1"
    direction="column"
    backgroundColor="kgray.100"
    alignItems="center"
    justify="center"
    p="6"
    gap="16"
  >
    <Text fontSize="4xl" textAlign="center" color="kgray.500">
      {title}
    </Text>

    {children}

    {footer && (
      <Text fontSize="lg" color="kgray.300" textAlign="center">
        {footer}
      </Text>
    )}
  </Flex>
);
